import { IconButton, IconButtonProps } from '@mui/material';
import { ReactElement } from 'react';

export type PoolIconButtonProps = IconButtonProps;

/**
 * PoolButton<br>
 * <a href="https://www.figma.com/file/kjfAT06qgLdW52cF1SqWuy/Pool-Alpin-Shop-2.0-Library?node-id=662%3A15734" target="_blank">Open in Figma</a>
 */
export const PoolIconButton = (props: PoolIconButtonProps): ReactElement => <IconButton {...props} />;
